import _ from 'underscore'
import Backbone from 'backbone'
import $ from 'jquery'
import { getConditionSummary } from 'util/conditions'

import {
    formatDate,
    formatTime,
    humanSeconds
} from 'util/twistle'

const WorkflowDefinition = Backbone.Model.extend({
    initialize: function(attribs) {
        this.updateAttributes();
    },
    url: function() {
        return "/workflows/View?workflow_definition_id=" + this.get("id");
    },
    updateAttributes: function() {
        var self = this;

        // generate titleWithOrgName
        self.attributes.titleWithOrgName = self.attributes.title;
        var org = App.account.getOrgById(self.attributes.organization);
        if(org)
        {
            let orgExtendedProps = org.extended_props || {};
            let orgWorkflowDefaults = orgExtendedProps.workflow_defaults || {};
            // use full org name
            self.attributes.titleWithOrgName += " (" + org.name + ")";
            self.attributes.orgName = org.name;
            self.attributes.canSelfEnroll =  orgExtendedProps.self_enroll_sms;
            self.attributes.canDisableTwoWaySMS = orgExtendedProps.allow_two_way_sms;
            self.attributes.allow_message_time_randomness = orgWorkflowDefaults.allow_message_time_randomness;
            self.attributes.enable_allow_dynamic_time_window = orgWorkflowDefaults.enable_allow_dynamic_time_window;
            self.attributes.enable_allow_minimum_time_gap = orgWorkflowDefaults.enable_allow_minimum_time_gap;
            self.attributes.tracker_default_per_page = orgWorkflowDefaults.tracker_default_per_page;
            self.attributes.tracker_default_show_recent_steps = orgWorkflowDefaults.tracker_default_show_recent_steps;
            self.attributes.tracker_default_show_active_mode = orgWorkflowDefaults.tracker_default_show_active_mode;
            self.attributes.tracker_comments_required = orgWorkflowDefaults.tracker_comments_required;
            self.attributes.tracker_can_edit_comments = orgWorkflowDefaults.tracker_can_edit_comments;
            self.attributes.allow_staff_to_add_self_to_conversations = orgWorkflowDefaults.allow_staff_to_add_self_to_conversations;
            self.attributes.hide_pause = orgWorkflowDefaults.hide_pause;
            // admin staff can edit others comments
            self.attributes.tracker_can_edit_others_comments = self.attributes.tracker_can_edit_comments && org.admin;
            self.attributes.export_button_visible = orgWorkflowDefaults.export_button_visible;
            self.attributes.hide_status_in_history = orgWorkflowDefaults.hide_status_in_history;
            self.attributes.enable_dynamic_forms = orgExtendedProps.enable_dynamic_forms;
            self.attributes.show_workflow_engine_status_in_history = orgWorkflowDefaults.show_workflow_engine_status_in_history;
            self.attributes.atc_on_history = orgWorkflowDefaults.atc_on_history;
            self.attributes.show_atc_last_updated = orgWorkflowDefaults.show_atc_last_updated;
            self.attributes.show_follow_ext_customer_id = orgWorkflowDefaults.show_follow_ext_customer_id;
            self.attributes.allow_auto_distribute_start_date = orgWorkflowDefaults.allow_auto_distribute_start_date;
            self.attributes.allow_message_extended_body = orgWorkflowDefaults.allow_message_extended_body;
            self.attributes.show_workflow_execution_filters_on_conversations_view = orgWorkflowDefaults.show_workflow_execution_filters_on_conversations_view;

            // any custom clinical filters configured on the org?
            self.attributes.clinical_filter_list = Object.keys(
                orgExtendedProps.clinical_data_index_settings || {}).map(index_key => {
                    return {index_key: index_key, title: orgExtendedProps.clinical_data_index_settings[index_key].title}
            });
            self.attributes.has_clinical_filters = self.attributes.clinical_filter_list.length > 0;

            let clinical_filter_list = Object.keys(
                orgExtendedProps.clinical_data_index_settings || {}).map(index_key => {
                    return {
                        index_key: index_key,
                        title: orgExtendedProps.clinical_data_index_settings[index_key].title,
                        has_value_lookup: false
                    }
            });

            let prop_filter_list = Object.keys(
                orgExtendedProps.workflow_defaults?.tracker_custom_filters || {}).map(index_key => {
                    return {
                        index_key: index_key,
                        title: orgExtendedProps.workflow_defaults?.tracker_custom_filters[index_key].label,
                        has_value_lookup: true
                    }
            });

            self.attributes.custom_filter_list = [...clinical_filter_list, ...prop_filter_list];
            self.attributes.has_custom_filters = self.attributes.custom_filter_list.length > 0;

        }

        self.attributes.showId = App.account.get("user_admin"); // user admins see IDs in the UI
        self.attributes.showAudit = App.account.canEditFormsAndWorkflows(); // and can see audit

        // user admins + certfied builders see editing features
        self.attributes.showEditable = self.attributes.showId || App.account.canEditFormsAndWorkflows();

        // standard (non admin) users can't see step(s)
        self.attributes.showSteps = self.attributes.showId || org?.admin;

        // and the ability to set/change the workflow's external identifier (used in integration(s))
        self.attributes.showExternalId = self.attributes.showEditable;

        self.attributes.isWorkflow = true; // helps w/ some generic UI elements that work on both forms and workflows

        // for templating out which content export types this workflow allows (currently set by environment)
        self.attributes.content_export_allowed_types?.forEach(
            f => { self.attributes["allowedContentExport" + f.toUpperCase()] = true; }
        );

        // unpack data from intake form / config form definitions
        _.each(["execute_on_submission_of_form_definition", "configuration_form_definition", "tracker_data_form_definition"], function(formAttribute){
            if(self.attributes[formAttribute] && _.has(self.attributes.workflow_form_definitions, self.attributes[formAttribute]))
            {
                self.attributes[formAttribute + "_data"] = self.attributes.workflow_form_definitions[self.attributes[formAttribute]];
                self.attributes[formAttribute + "_title"] = self.attributes[formAttribute+"_data"].title;
            }
        });

        _.each(self.attributes.workflow_actors||[],function(actor){
            self.attributes["actor_" + actor.identifier] = actor;
            if(actor.target)
            {
                self.attributes.target_actor_name = actor.label;
            }
            if (!actor.extended_props || typeof (actor.extended_props) !== 'object') {
                // deserialize extended props (only once)
                actor.extended_props = JSON.parse(actor.extended_props || "{}");
            }
        });

        // build up a map of topics -> step ids for later dereferencing

        let parseOnce = function(attr) {
            return (!attr || typeof(attr) !== 'object') ? JSON.parse(attr || '{}') : attr;
        }

        self.attributes.extended_props = parseOnce(self.attributes.extended_props)
        self.attributes.custom_status_images = parseOnce(self.attributes.custom_status_images)

        self.attributes.topic_list = _.map(self.attributes.extended_props.topics || {}, function(v,k){
            return {id:k, label:v, value:v, in_use:0};
        });

        // merged status list
        let builtInStatusList = {};

        (App.config.get("wf_action_status_list") || []).forEach((k, i) => {
            builtInStatusList[k] = i
        });

        let statusList = (Object.keys(self.attributes.extended_props.custom_status_list || {}).length > 0 ?
            self.attributes.extended_props.custom_status_list : builtInStatusList);

        self.attributes.action_status_list = Object.keys(statusList || {}).map(function(statusKey){
            var val = {key:statusKey};

            val.custom_image_data = self.attributes.custom_status_images[statusKey];
            val.label = statusList[statusKey].label
            val.isCustomStatus = statusKey.startsWith("cust_");
            return val;
        });

        self.attributes.can_access_clinical_data = self.attributes.extended_props.can_access_clinical_data;
        self.attributes.adopt_template_updates = self.attributes.extended_props.adopt_template_updates;

        // message timing randomness override
        self.attributes.message_time_randomness = self.attributes.extended_props.message_time_randomness;

        // minimum time gao setting
        self.attributes.minimum_time_gap = self.attributes.extended_props.minimum_time_gap;

        // whether to allow dynamic time-of-day
        self.attributes.allow_dynamic_time_window = self.attributes.extended_props.allow_dynamic_time_window;

        // per-workflow configuration of "recent steps" columns shown
        self.attributes.recent_steps_shown = self.attributes.extended_props.recent_steps_shown;
        if (!self.attributes.recent_steps_shown && self.attributes.tracker_max_home_columns) {
            // if there was a previously set org-wide tracker max, and nobody has overwritten it with
            // a new per-workflow value, preserve that value and behavior
            self.attributes.recent_steps_shown = self.attributes.tracker_max_home_columns;
        }

        // tracker "recent steps" shows scheduled steps
        self.attributes.tracker_hides_scheduled_steps = self.attributes.extended_props.tracker_hides_scheduled_steps;

        // Metadata fields
        self.attributes.service_line = self.attributes.extended_props.service_line;
        self.attributes.workflow_roi = self.attributes.extended_props.workflow_roi;

        self.attributes.metadata_list = _.map(self.attributes.extended_props.metadata || {}, function (field, key) {
            return {'id': field.ux_id, 'key': key, 'value': field.field_value};
        });

        self.attributes.can_track_workflow = (
            _.indexOf(App.account.getOrgById(self.attributes.organization).capabilities, 't') > -1 ||
            App.account.get("admin") || App.account.get("user_admin"));

        // default for "home_visible_mode" is "show executions"
        if(self.attributes.home_visible && !self.attributes.extended_props.home_visible_mode){
            self.attributes.extended_props.home_visible_mode = "show_executions";
        }

        let statsTs = self.attributes.extended_props?.stats_calc_timestamp;
        if(statsTs){
            self.attributes.stats_calc_timestamp_formatted = formatDate(statsTs);
        }

        // if we are viewing a workflow in an organization other than the one in which it is defined, hoist up
        // org-specific execution stats
        const currentOrgId = App.account.getDefaultOrg()?.id;
        if(currentOrgId !== self.attributes.organization){
            [
                "active_executions_count",
                "active_executions_count_all_versions",
                "recent_executions_count",
                "total_executions_count",
                "total_executions_count_all_versions"
                ].forEach(attrib => {
                self.attributes[attrib] = self.attributes.extended_props?.org_execution_counts?.[attrib]?.[currentOrgId] || 0;
            });
        }


        let activitySteps = self.attributes.workflow_activity_steps||[];

        _.each(activitySteps,function(activityStep, idx)
        {
            self.attributes.hasSteps = true;
            self.augmentStepProps(activityStep);
            activityStep.hasNext = activitySteps.length > 1 && idx < (activitySteps.length - 1);
        });

        // augment sub wfs
        Object.entries(self.attributes.workflow_workflow_definitions || {}).forEach(subWf => {
            self.attributes.workflow_workflow_definitions[subWf[0]] = new WorkflowDefinition(subWf[1]).toJSON();
        })

        // possibly explode out subworkflows for the tracker
        self.attributes.tracker_steps = [];

        activitySteps.forEach(activityStep => {
            self.attributes.tracker_steps.push(activityStep);

            // Check actions for sub workflows
            let subWFSteps = [
                                ...(activityStep.submission_actions || []),
                                ...(activityStep.delinquency_actions || []),
                                ...(activityStep.reply_actions || []),
                                ...(activityStep.read_actions || [])]
                                .filter(action => action.activity_type_start_workflow && action.show_sub_workflow_on_tracker)
                                .map(action => ({ ...action, id: activityStep.id, delay_days: activityStep.delay_days}));
            if (subWFSteps) {
                self.attributes.has_sub_workflows_on_tracker = true;
            }

            // Add in sub workflow steps
            if (activityStep.activity_type_start_workflow && activityStep.show_sub_workflow_on_tracker) {
                self.attributes.has_sub_workflows_on_tracker = true;
                subWFSteps.push(activityStep);
            }

            // Augment any sub workflows for display
            subWFSteps.forEach(step => {
                let subWF = self.attributes.workflow_workflow_definitions?.[step.workflow_definition_id];
                (subWF?.workflow_activity_steps || []).forEach(subStep => {
                    subStep.parent_activity_step_id = step.id;
                    subStep.workflow_definition_id = step.workflow_definition_id;
                    subStep.isDisplayedSubstep = true;
                    if(self.attributes.step_delay_day_timing_mode &&
                        subWF.step_delay_day_timing_mode &&
                        !self.attributes.executes_relative_to_target_date){
                        // see re-sort behavior below:
                        subStep.subWorkflowAdjustedDelayDays = step.delay_days + subStep.delay_days;
                    }
                    self.attributes.tracker_steps.push(subStep);
                });
            });
        });

        // re-sort tracker steps if sub-workflow(s) are included
        // this resort requires both parent and sub-workflow in `step_delay_day_timing_mode`
        // there is added complexity for non-target-date (not `executes_relative_to_target_date`) - because
        // the actual position of a sub-workflow's step is relative to the position of where it was launched
        // this is why we calculate `subWorkflowAdjustedDelayDays` on sub-workflow steps above
        if(self.attributes.has_sub_workflows_on_tracker && self.attributes.step_delay_day_timing_mode){
            self.attributes.tracker_steps.sort((stepA, stepB) => {
                if(self.attributes.executes_relative_to_target_date){
                    // target date mode - just sort by negative delay days
                    if(stepA.delay_days === stepB.delay_days){
                        return stepA.time_window_start_raw > stepB.time_window_start_raw ? 1 : -1;
                    }
                    return stepA.delay_days < stepB.delay_days ? 1 : -1;
                } else {
                    // normal (outwards) timing - needs to use the "calculated" delay of the step if available
                    let stepADay = stepA.subWorkflowAdjustedDelayDays || stepA.delay_days,
                        stepBDay = stepB.subWorkflowAdjustedDelayDays || stepB.delay_days;
                    if(stepADay === stepBDay){
                        return stepA.time_window_start_raw > stepB.time_window_start_raw ? 1 : -1;
                    }
                    return stepADay > stepBDay ? 1 : -1;
                }
            });
        }

        // normalize hook data into something the step editor can use
        self.attributes.workflowHookStepData = self.augmentStepProps(
            {
                activity_type: "configure_hooks",
                activity_props: JSON.stringify({"workflow_hooks":self.attributes.extended_props.workflow_hooks || []})
            }
        );

        // normalize versions
        self.attributes.versions = _.map(self.attributes.workflow_versions || [], function (version) {
            if (version.id == self.attributes.id) {
                version.is_current = true;
            }
            return version;
        });

        if(self.attributes.versions.length > 1){
            self.attributes.show_steps_all_version_label = `(v${self.attributes.version_num})`
        }

        self.attributes.sub_workflows_used = _.map(self.attributes.workflow_workflow_definitions || [], function (wfd) {
            return {
                id: wfd.id,
                seqnum: wfd.attachment_ref?.seqnum,
                title: wfd.title,
                version_num: wfd.version_num
            }
        });
        self.attributes.has_sub_workflows = self.attributes.sub_workflows_used.length > 0;

        self.attributes.forms_used = _.map(self.attributes.workflow_form_definitions || [], function (fd) {
            return {
                id: fd.id,
                seqnum: fd.attachment_ref.seqnum,
                title: fd.title,
                version_num: fd.version_num
            }
        });
        self.attributes.has_forms = self.attributes.forms_used.length > 0;

        self.attributes.parent_workflows_used = _.map(self.attributes.dependent_workflow_definitions || [], function (wfd) {
            return {
                id: wfd.id,
                seqnum: wfd.attachment_ref.seqnum,
                title: wfd.title,
                version_num: wfd.version_num
            }
        });
        self.attributes.has_parent_workflows = self.attributes.parent_workflows_used.length > 0;

        // used to track whether JSON from the server has already passed through here
        self.attributes.isAugmentedModel = true;

    },

    setReadOnly: function() {
        var self = this;

        self.attributes.showExternalId = false;
        self.attributes.showEditable = false;
        return self; // enable chaining
    },

    augmentStepProps: function(activityStep) {
        var self = this;

        // some mustache help
        activityStep.delay = activityStep.delay || 0;
        activityStep.recur_delay = activityStep.recur_delay || 0;

        if(self.attributes.step_delay_day_timing_mode)
        {
            activityStep.delay_number = activityStep.delay_days;
            activityStep.delay_units = "day(s)";
            activityStep.delay_units_display = "day(s)";
        }
        else
        {
            var delayParts = humanSeconds(activityStep.delay);
            activityStep.delay_number = delayParts.value;
            activityStep.delay_units = delayParts.units;
            activityStep.delay_units_display = delayParts.displayUnits;
        }
        var recurDelayParts = humanSeconds(activityStep.recur_delay);
        activityStep.recur_delay_number = recurDelayParts.value;
        activityStep.recur_delay_units = recurDelayParts.units;
        activityStep.recur_delay_units_display = recurDelayParts.displayUnits;

        activityStep.can_recur = true;

        if(self.attributes.executes_relative_to_target_date)
        {
            activityStep.can_recur = false;
            activityStep.executes_relative_to_target_date = true;
            activityStep.target_date_label = self.attributes.target_date_label;
        }

        if(self.attributes.step_delay_day_timing_mode)
        {
            activityStep.can_recur = false;
            activityStep.step_delay_day_timing_mode = true;
            activityStep.delay_units = "days";
        }

        if(self.attributes.start_on_date)
        {
            activityStep.start_on_date = true;
            activityStep.start_date_label = self.attributes.start_date_label;
        }

        activityStep.actors = self.attributes.workflow_actors;

        _.extend(activityStep, JSON.parse(activityStep.activity_props || "{}"));


        activityStep.display_on_tracker = activityStep.display_on_tracker !== false; // default visible / editable prop

        if(activityStep.quick_label === "")
        {
            activityStep.quick_label = undefined; // force blank string to falsey (mustache.js bug)
        }

        activityStep = self._augmentStepOrActionProps(activityStep, null, "step_level");

        activityStep["positive_step_actions_display"] = [];
        activityStep["negative_step_actions_display"] = [];

        if (activityStep.activity_type === "send_form" && (activityStep.submission_actions || []).length > 0) {
            activityStep["positive_step_actions_display"].push({
                text: `${activityStep.submission_actions.length} action${activityStep.submission_actions.length > 1 ? "s" : ""} following form submission`,
                type: "submission_actions"
            });
            activityStep.submission_actions = activityStep.submission_actions.map(a => self._augmentStepOrActionProps(a, activityStep, `submission_actions_${a.action_definition_id}`));
        }
        if (activityStep.activity_type === "send_form" && (activityStep.delinquency_actions || []).length > 0) {
            activityStep["negative_step_actions_display"].push({
                text: `${activityStep.delinquency_actions.length} action${activityStep.delinquency_actions.length > 1 ? "s" : ""} when form is <b>not</b> submitted`,
                type: "delinquency_actions"
            });
            activityStep.delinquency_actions = activityStep.delinquency_actions.map(a => self._augmentStepOrActionProps(a, activityStep, `delinquency_actions_${a.action_definition_id}`));
        }
        if ((activityStep.activity_type === "send_message" || activityStep.activity_type === "send_form")  && (activityStep.reply_actions || []).length > 0) {
            activityStep["positive_step_actions_display"].push({
                text: `${activityStep.reply_actions.length} action${activityStep.reply_actions.length > 1 ? "s" : ""} taken following reply.`,
                type: "reply_actions"
            });
            activityStep.reply_actions = activityStep.reply_actions.map(a => self._augmentStepOrActionProps(a, activityStep, `reply_actions_${a.action_definition_id}`));
        }
        if (activityStep.activity_type === "send_message" && (activityStep.delinquency_actions || []).length > 0) {
            activityStep["negative_step_actions_display"].push({
                text: `${activityStep.delinquency_actions.length} action${activityStep.delinquency_actions.length > 1 ? "s" : ""} when message is <b>not</b> viewed`,
                type: "delinquency_actions"
            });
            activityStep.delinquency_actions = activityStep.delinquency_actions.map(a => self._augmentStepOrActionProps(a, activityStep, `delinquency_actions_${a.action_definition_id}`));
        }
        if ((activityStep.activity_type === "send_message" || activityStep.activity_type === "send_form")
            && (activityStep.read_actions || []).length > 0) {
            activityStep["positive_step_actions_display"].push({
                text: `${activityStep.read_actions.length} action${activityStep.read_actions.length > 1 ? "s" : ""} taken when message is opened/viewed.`,
                type: "read_actions"
            });
            activityStep.read_actions = activityStep.read_actions.map(a => self._augmentStepOrActionProps(a, activityStep, `read_actions_${a.action_definition_id}`));
        }
        if ((activityStep.activity_type === "send_message" || activityStep.activity_type === "send_form")
            && (activityStep.link_used_actions || []).length > 0) {
            activityStep["positive_step_actions_display"].push({
                text: `${activityStep.link_used_actions.length} action${activityStep.link_used_actions.length > 1 ? "s" : ""} taken when a URL is clicked.`,
                type: "link_used_actions"
            });
        }


        // for easier display of followup actions
        activityStep.positive_step_actions = [...(activityStep.submission_actions || []),
                                              ...(activityStep.reply_actions || []),
                                              ...(activityStep.read_actions || [])];
        activityStep.negative_step_actions = activityStep.delinquency_actions || [];

        // Allows for the display of execution time in the workflow step dialog
        if (activityStep.time_window_start && !activityStep.time_window_augmented) {
            activityStep.time_window_tz = self.attributes.default_tz;
            activityStep.time_window_start_raw = activityStep.time_window_start;
            activityStep.time_window_start = formatTime(activityStep.time_window_start);
            activityStep.time_window_augmented = true; // only do this once
        }

        if (activityStep.all_delay_day_times) {
            activityStep.all_delay_day_times = activityStep.all_delay_day_times.map(x => {
                return {
                    ...x,
                    time_window_start: formatTime(x.time_window_start)
                };
            });
        }

        return activityStep;

    },

    _augmentStepOrActionProps: function(stepOrActionProps, baseStepProps, condition_key){
        const self = this;
        // this function sets up display variables for mustache for displaying the properties of a step,
        // or the properties of a followup action. Since this is rendered using mustache in a nested fashion,
        // we have to make sure that the followup actions specifically disable/block inheritence from the same
        // vars defined at the step level. When working a followup action, we supply the base "step" props as
        // the second parameter (`baseStepProps`)

        // coalesce "type" and "activity_type"
        if(!stepOrActionProps.activity_type && stepOrActionProps.type){
            stepOrActionProps.activity_type = stepOrActionProps.type.toLowerCase();
        }

        // disable all UI flags for what type of step (or followup action this is)
        stepOrActionProps["activity_type_manage_connections"] = false;
        stepOrActionProps["activity_type_send_message"] = false;
        stepOrActionProps["activity_type_send_form"] = false;
        stepOrActionProps["activity_type_call_service"] = false;
        stepOrActionProps["activity_type_set_action_status"] = false;
        stepOrActionProps["activity_type_control_workflow"] = false;
        stepOrActionProps["activity_type_store_data"] = false;

        // now turn on the right one
        stepOrActionProps["activity_type_" + stepOrActionProps.activity_type] = true;

        // actor props that need display versions
        _.each(["from_actor", "target_to_actor_list", "stream_to_actor_list", "to_actor"],function(prop){
            if(stepOrActionProps[prop])
            {
                // place singular props into a list
                var propList = $.isArray(stepOrActionProps[prop]) ? stepOrActionProps[prop]: [stepOrActionProps[prop]];

                var labels = _.map(propList,function(actorId){
                    var actor = self.attributes["actor_" + actorId];
                    return actor ? actor.label : actorId;
                });
                stepOrActionProps[prop + "_display"] = (labels && labels.join(",")) || "";
            }

        });

        stepOrActionProps.activity_type_sends_message = (stepOrActionProps.activity_type === "send_message" ||
                                                         stepOrActionProps.activity_type === "send_form" ||
                                                         stepOrActionProps.activity_type === "start_conversation"); // flag for UI/template

        if(stepOrActionProps.activity_type_sends_message){
            // augment alternate content
            _.each(["notification_message", "message_body"], key => {
                if(stepOrActionProps[`${key}_alternates`]?.length > 0){
                    stepOrActionProps[`${key}_alternates`] = stepOrActionProps[`${key}_alternates`].map((a, i) =>  {
                        return {
                            idx: i + 2, // include the "default" notification message
                            alternateContentType: key,
                            alternateContent: a,
                            unique_id: (i + 1) * new Date().getTime(),
                            textAreaClass: key == "notification_message" ? "single-line-textarea" : "message_body_text_area"
                        };
                    });
                    stepOrActionProps[`${key}_alternates_count`] = stepOrActionProps[`${key}_alternates`].length;
                }
            });
        }

        if(stepOrActionProps.activity_type === "send_form")
        {
            if(_.has(self.attributes.workflow_form_definitions, stepOrActionProps.form_definition_id))
            {
                stepOrActionProps["form_definition_title"] = self.attributes.workflow_form_definitions[
                    stepOrActionProps.form_definition_id].title;
                if (self.attributes.showId)
                {
                    stepOrActionProps["form_definition_title"] += " (" + stepOrActionProps.form_definition_id + ")";
                }
            }
        }
        else {
            stepOrActionProps.form_definition_title = undefined;
        }

        if(stepOrActionProps.activity_type === "manage_connections")
        {
            switch(stepOrActionProps.relationship)
            {
                case "patient":
                    stepOrActionProps.relationship_display = "Patient/Client";
                    break;
                case "professional":
                    stepOrActionProps.relationship_display = "Private Contact";
                    break;
                case "org-member":
                    stepOrActionProps.relationship_display = "Staff Member";
                    break;
            }
        }

        // deal w/ topics
        if(stepOrActionProps.topic_id)
        {
            stepOrActionProps.topic_label = self.attributes.extended_props.topics[stepOrActionProps.topic_id];
            var topic = _.findWhere(self.attributes.topic_list,{id:stepOrActionProps.topic_id});
            if(topic)
            {
                topic.in_use += 1;
            }
        } else{
            stepOrActionProps.topic_label = undefined;
        }

        if(stepOrActionProps.attachments && stepOrActionProps.attachments.length > 0)
        {
            stepOrActionProps.attachments_info = _.map(stepOrActionProps.attachments.split(",") || [], function(seqnum){
                let attach = self.attributes.workflow_attachments[seqnum];
                if(attach)
                {
                    return {...attach, ...{thumbSize: attach.type === "image" ? "std" : "prf"}};
                }
            }).filter(a => a);
        }
        else {
            stepOrActionProps.attachments = undefined;
        }

        if(stepOrActionProps.activity_type === "start_workflow")
        {
            if(_.has(self.attributes.workflow_workflow_definitions, stepOrActionProps.workflow_definition_id))
            {
                stepOrActionProps["workflow_definition_title"] = self.attributes.workflow_workflow_definitions[
                    stepOrActionProps.workflow_definition_id].title;

                if (self.attributes.showId)
                {
                    stepOrActionProps["workflow_definition_title"] += " (" + stepOrActionProps.workflow_definition_id + ")";
                }
            }
        }

        if (stepOrActionProps.activity_type === "control_workflow") {
            stepOrActionProps[`workflow_control_action_${stepOrActionProps.workflow_control_action}`] = true;
        }

        if (stepOrActionProps.activity_type === "store_data") {
            stepOrActionProps[`workflow_control_action_${stepOrActionProps.workflow_control_action}`] = true;
        }

        if(stepOrActionProps.action_status) {
            stepOrActionProps.status = stepOrActionProps.action_status;
            stepOrActionProps.action_status_display = _.findWhere(self.attributes.action_status_list,
                {key: stepOrActionProps.action_status});
        }

        // generate a user-readable description of conditionals applied to this step (or follow up action)
        let preconditionContent = "", preconditions, form;
        if (baseStepProps) {
            preconditions = JSON.parse(baseStepProps.preconditions || "{}");
            form = self.attributes.workflow_form_definitions?.[baseStepProps.form_definition_id];
        } else {
            preconditions = JSON.parse(stepOrActionProps.preconditions || "{}");
            form = self.attributes.execute_on_submission_of_form_definition_data;
        }

        if (!_.isEmpty(preconditions[condition_key])) {
            preconditionContent = self._getStepPreconditionSummary(
                preconditions[condition_key],
                self.attributes.action_status_list,
                form
            );
        }

        stepOrActionProps["activity_preconditions_display"] = preconditionContent;

        if (stepOrActionProps.extended_message_body == undefined) {
            stepOrActionProps.extended_message_body = null;
        }

        return stepOrActionProps;
    },

    _getStepPreconditionSummary: function(conditionSet, actionStatusList, formDef) {
        let conditionSetCount = 0,
            summary = '',
            operator = conditionSet.require_all ? "AND " : "OR ",
            lastCondition = _.last(conditionSet.conditions);

        operator = `<i>${operator}</i><br />`;
        _.each(conditionSet.conditions, condition => {
            if (condition.type == "condition_set") {
                conditionSetCount++;
            } else if (lastCondition === condition) {
                summary += getConditionSummary(condition, " ", actionStatusList, formDef);
            } else {
                summary += getConditionSummary(condition, operator, actionStatusList, formDef);
            }
        });

        const conText = conditionSetCount > 1 ? "other condition sets" : "other condition set";
        if (conditionSetCount) {
            if (lastCondition.type == "condition_set") {
                summary += `<b>${conditionSetCount} ${conText}</b>`;
            } else {
                summary += `${operator} <b>${conditionSetCount} ${conText}</b>`;
            }
        }

        return summary;
    },
});

export default WorkflowDefinition;